//
//
//
//
//
//

export default {
  name: "index",
  data(){
    return {
      
    }
  },
  mounted () {
    
  },
  created() {
    
  },
  methods:{
    
  },
}



// WEBPACK FOOTER //
// ./src/components/index.vue